export default "/_next/static/images/68b8d0c5b3fd5c2599bf9a6d52d16a35.png";